var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.6875H23V21.3125L27.6875 24.125L26.6875 25.75L21 22.3125V15.6875ZM13.8125 12.5C16.1875 10.1667 19.0208 9 22.3125 9C25.6042 9 28.4167 10.1667 30.75 12.5C33.125 14.8333 34.3125 17.6667 34.3125 21C34.3125 24.3333 33.125 27.1667 30.75 29.5C28.4167 31.8333 25.6042 33 22.3125 33C20.9375 33 19.4167 32.6667 17.75 32C16.125 31.2917 14.8333 30.4583 13.875 29.5L15.75 27.5625C17.5833 29.3958 19.7708 30.3125 22.3125 30.3125C24.8958 30.3125 27.1042 29.4167 28.9375 27.625C30.7708 25.7917 31.6875 23.5833 31.6875 21C31.6875 18.4167 30.7708 16.2292 28.9375 14.4375C27.1042 12.6042 24.8958 11.6875 22.3125 11.6875C19.7292 11.6875 17.5208 12.6042 15.6875 14.4375C13.8958 16.2292 13 18.4167 13 21H17L11.625 26.375L11.5 26.1875L6.3125 21H10.3125C10.3125 17.6667 11.4792 14.8333 13.8125 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.47edfacc78d72afa093d10ca98b0a1a1.svg";
export { ForwardRef as ReactComponent };